import { Container, DisplayObject, Point, Sprite } from "pixi.js";
import { BACKGROUND_CITY_1_IMG, BACKGROUND_CITY_2_IMG, BACKGROUND_CLOUDS_1_IMG, BACKGROUND_CLOUDS_2_IMG, BACKGROUND_FOREST_IMG, BACKGROUND_MOUNTAINS_IMG, BACKGROUND_ROAD_IMG, BACKGROUND_SKY_IMG, BACKGROUND_SUN_IMG, Level1, Level2, LVL2_BACKGROUND_CITY_1_IMG, LVL2_BACKGROUND_CITY_2_IMG, LVL2_BACKGROUND_FOREST_IMG, LVL2_BACKGROUND_MOUNTAINS_IMG, LVL2_BACKGROUND_ROAD_IMG, LVL2_BACKGROUND_SKY_IMG, LVL2_BACKGROUND_SUN_IMG } from "../Constants/ImageConstants";
import { SpineConst } from "../Constants/SpineConst";
import { SpineContainer } from "./Common/SpineContainer";
import { GameScreenController } from "./Game/GameScreenController";

export function buildLevel(controller: GameScreenController) {

}

export function initLevel2(controller: GameScreenController) {
    controller["snowCity"] = new SpineContainer(controller.$model, ["location_2_back_salut"], SpineConst.level2City);
    window["city"] = controller["snowCity"];
    controller.unparallaxedBack['background'] = createTiles(controller._background, LVL2_BACKGROUND_SKY_IMG, new Point(0.5, 1));
    controller.parallaxedBack['mountains'] = createTiles(controller._background, LVL2_BACKGROUND_MOUNTAINS_IMG, new Point(0.5, 1));
    controller.unparallaxedBack['stars'] = createSprite(controller._background, LVL2_BACKGROUND_SUN_IMG, new Point(0.5, 1), 1.25);
    controller.parallaxedBack['city1'] = createSprite(controller._background, LVL2_BACKGROUND_CITY_1_IMG, new Point(0.5, 1));
    //controller.parallaxedBack['city2'] = createSprite(controller._background, LVL2_BACKGROUND_CITY_2_IMG, new Point(0.5, 1));
    controller.parallaxedBack['city2'] = (controller["snowCity"] as SpineContainer).container;
    controller._background.addChild((controller["snowCity"] as SpineContainer).container);
    controller.parallaxedBack['forest'] = createTiles(controller._background, LVL2_BACKGROUND_FOREST_IMG, new Point(0.5, 1));
    controller.unparallaxedBack['road'] = createSprite(controller._container, LVL2_BACKGROUND_ROAD_IMG, new Point(0.5, 0.2));
    controller.unparallaxedBack['road'].scale.x = 15;
    controller.unparallaxedBack['road'].scale.y = 10;
}

export function updateLevel2Width(controller: GameScreenController, width: number) {
    controller.unparallaxedBack['background'].width = width;
    controller.unparallaxedBack['background'].height = controller.unparallaxedBack['background'].texture.baseTexture.height;
    controller.parallaxedBack['mountains'].width = width;
    controller.parallaxedBack['mountains'].height = controller.parallaxedBack['mountains'].texture.baseTexture.height;
    controller.parallaxedBack['forest'].width = width;
    controller.parallaxedBack['forest'].height = controller.parallaxedBack['forest'].texture.baseTexture.height;
}

export function initLevel1(controller: GameScreenController) {
    controller["snowCity"] = new SpineContainer(controller.$model, ["location_1_back_salut"], SpineConst.level1City);
    // (controller["snowCity"] as SpineContainer).container.scale.set(2.5);
    window["city"] = controller["snowCity"];
    // (controller["snowCity"] as SpineContainer).setAnimation("location_1_back_salut", false);
    controller.unparallaxedBack['sky'] = createTiles(controller._background, BACKGROUND_SKY_IMG, new Point(0.5, 1));
    controller.parallaxedBack['cloud1'] = createTiles(controller._background, BACKGROUND_CLOUDS_1_IMG, new Point(0.5, 1), 2);
    controller.parallaxedBack['mountains'] = createTiles(controller._background, BACKGROUND_MOUNTAINS_IMG, new Point(0.5, 1));
    controller.unparallaxedBack['sun'] = createSprite(controller._background, BACKGROUND_SUN_IMG, new Point(0.5, 1), 1.25);
    controller.parallaxedBack['cloud2'] = createTiles(controller._background, BACKGROUND_CLOUDS_2_IMG, new Point(0.5, 1), 2);
    controller.parallaxedBack['city1'] = createSprite(controller._background, BACKGROUND_CITY_1_IMG, new Point(0.5, 1));
    controller.parallaxedBack['city2'] = (controller["snowCity"] as SpineContainer).container;
    controller._background.addChild((controller["snowCity"] as SpineContainer).container);
    (controller["snowCity"] as SpineContainer).container.y = -13.69;
    // controller.parallaxedBack['city2'] = createSprite(controller._background, BACKGROUND_CITY_2_IMG, new Point(0.5, 1));
    controller.parallaxedBack['forest'] = createTiles(controller._background, BACKGROUND_FOREST_IMG, new Point(0.5, 1));
    controller.unparallaxedBack['road'] = createSprite(controller._container, BACKGROUND_ROAD_IMG, new Point(0.5, 0.2));
    controller.unparallaxedBack['road'].scale.x = 15;
    controller.unparallaxedBack['road'].scale.y = 10;
}

export function updateLevel1Width(controller: GameScreenController, width: number) {
    controller.unparallaxedBack['sky'].width = width;
    controller.unparallaxedBack['sky'].height = controller.unparallaxedBack['sky'].texture.baseTexture.height;
    controller.parallaxedBack['mountains'].width = width;
    controller.parallaxedBack['mountains'].height = controller.parallaxedBack['mountains'].texture.baseTexture.height;
    controller.parallaxedBack['cloud1'].width = width;
    controller.parallaxedBack['cloud1'].height = controller.parallaxedBack['cloud1'].texture.baseTexture.height;
    controller.parallaxedBack['cloud2'].width = width;
    controller.parallaxedBack['cloud2'].height = controller.parallaxedBack['cloud2'].texture.baseTexture.height;
    controller.parallaxedBack['forest'].width = width;
    controller.parallaxedBack['forest'].height = controller.parallaxedBack['forest'].texture.baseTexture.height;
}

function createTiles(parent: Container | null, img: any, anchor: Point, scale: number = 1) {
    const sprite = new PIXI.extras.TilingSprite(PIXI.Texture.from(img));
    sprite.anchor.set(anchor.x, anchor.y);
    sprite.scale.set(scale);
    parent?.addChild(sprite);
    return sprite
}

function createSprite(parent: Container | null, img: any, anchor: Point, scale: number = 1) {
    const sprite = new Sprite(PIXI.Texture.from(img));
    sprite.anchor.set(anchor.x, anchor.y);
    sprite.scale.set(scale);
    parent?.addChild(sprite);
    return sprite
}
